import { useCallback, useState } from "react";
import adminApi from "../api/adminApi";

export default function useHubspotMappings(setBanner) {
  const [mappings, setMappings] = useState([]);
  const [mappingsLoading, setMappingsLoading] = useState(false);

  const loadMappings = useCallback(async () => {
    setMappingsLoading(true);
    try {
      const data = await adminApi.getHubspotMappings();
      setMappings(Array.isArray(data) ? data : []);
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to load HubSpot mappings" });
    } finally {
      setMappingsLoading(false);
    }
  }, [setBanner]);

  return { mappings, mappingsLoading, loadMappings };
}
